export const BASE_PATH = {
    ERROR: '/error',
    WELCOME: '/welcome',
    USER_PROFILE: '/user-profile',
} as const;

export const GANDALF_LOGOUT_ENDPOINT =
    'https://login.us-east-1.auth.skillbuilder.aws/logout';
